import { ExerciseQuestionResponse } from "types/Redux"

export const getExerciseQuestionTitle = (questionItem: ExerciseQuestionResponse) =>
    questionItem?.linked_question
        ? `${questionItem?.question} ${questionItem?.linked_question?.question} ${questionItem?.post_question ?? ""}`
        : questionItem?.question
